"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import {
  html,
  SpectrumElement
} from "@spectrum-web-components/base";
import { property } from "@spectrum-web-components/base/src/decorators.js";
import panelStyles from "./tab-panel.css.js";
const _TabPanel = class _TabPanel extends SpectrumElement {
  constructor() {
    super(...arguments);
    this.selected = false;
    this.value = "";
  }
  handleFocusin() {
    this.removeAttribute("tabindex");
  }
  handleFocusout() {
    this.tabIndex = this.selected ? 0 : -1;
  }
  render() {
    return html`
            <slot
                @focusin=${this.handleFocusin}
                @focusout=${this.handleFocusout}
            ></slot>
        `;
  }
  firstUpdated() {
    this.slot = "tab-panel";
    this.setAttribute("role", "tabpanel");
    this.tabIndex = 0;
    if (!this.hasAttribute("id")) {
      this.id = `sp-tab-panel-${_TabPanel.instanceCount++}`;
    }
  }
  updated(changes) {
    if (changes.has("selected")) {
      if (this.selected) {
        this.removeAttribute("aria-hidden");
        this.tabIndex = 0;
      } else {
        this.setAttribute("aria-hidden", "true");
        this.tabIndex = -1;
      }
    }
  }
};
_TabPanel.styles = [panelStyles];
/**
 * @private
 */
_TabPanel.instanceCount = 0;
__decorateClass([
  property({ type: Boolean, reflect: true })
], _TabPanel.prototype, "selected", 2);
__decorateClass([
  property({ type: String, reflect: true })
], _TabPanel.prototype, "value", 2);
export let TabPanel = _TabPanel;
//# sourceMappingURL=TabPanel.dev.js.map
